const RECEIVE_ADENTITIES = 'src/adEntities/RECEIVE_ADENTITIES';
const CLEAR_ADENTITIES = 'src/adEntities/CLEAR_ADENTITIES';

export default {
  CLEAR_ADENTITIES,
  RECEIVE_ADENTITIES
};
